import { Component, OnInit } from '@angular/core';
import { ContextService } from 'src/app/services/application/context.service';
import { AuthService } from 'src/app/services/application/auth.service';
import { DivisionService } from 'src/app/services/business/division.service';
import { IDivision } from 'src/app/models/IDivision';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public userName: string;
  public userEmail: string;
  public scopeLogo: string;
  public scopeName: string;
  public sector: IDivision;
  public sectorImageUrl: string;

  public userRole: number;
  public scope: any;

  constructor(private router: Router, private context: ContextService, private divisionService: DivisionService) {

    this.userName = this.context.authService.userName;
    this.userEmail = this.context.authService.userEmail;
    this.sector = this.divisionService.currentDivision;
    this.userRole = Number(localStorage.getItem("userrole"));

    this.scope = this.context.authService.currentScope;
    if (this.scope) {
      this.scopeLogo = this.scope.brandImageUrl;
      this.scopeName = this.scope.name;
    }
    if (this.sector == null) {
      this.router.navigate(['/login']);
    } else {
      this.sectorImageUrl = this.sector.brandImageUrl;
    }

  }

  ngOnInit() {
  }

  hideMenus(menuName: string): boolean {
    if (this.scope.storage.hideMenu)
      return !this.scope.storage.hideMenu.includes(menuName);

    return true;
  }

  permissionMaster() {
    if (this.checkScopeRioBravo()) {
      return this.hideMenus('division');
    } else if (this.userRole === 255) {
      return true;
    }
    return false;
  }

  permissionAdmin() {
    if (this.userRole >= 127) {
      return true;
    }
    return false;
  }

  private checkScopeRioBravo(): boolean {
    return !isNullOrUndefined(this.scope) && this.scope.key === 'riobravo';
  }

}
